<template>
	<div>
		<div class="main">
			<ul>
				<li>
					<img src="../../../assets/img/privacy/infoPhone.png">
					<p>电话</p>
					<p>{{getServiceListAll.setPhone}}</p>
				</li>
				<li>
					<img src="../../../assets/img/privacy/infoWx.png">
					<p>微信</p>
					<p>{{getServiceListAll.setWx}}</p>
				</li>
				<li>
					<img src="../../../assets/img/privacy/infoQq.png">
					<p>QQ</p>
					<p>{{getServiceListAll.setQq}}</p>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
	import { appCSetupList } from "@/api/serviceInfo.js"
	let _self;
	export default {
		name: "",
		data() {
			return {
				getServiceListAll:[],
			}
		},
		beforeCreate() {
			_self = this;
		},
		created() {
			//获取联系客服信息
			_self.getServiceList();
		},
		// 方法集
		methods: {
			//调用联系客服列表接口
			getServiceList(){
				appCSetupList().then(res=>{
					if(res.data&&res.code==200){
						_self.getServiceListAll=res.data;
					}
				})
			}
		},
		// 组件集
		components: {

		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},
		// 过滤器
		filters: {

		},
		// 实例销毁
		destroyed() {

		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			next();
		},
	}
</script>

<style scoped>
	.main {
		width: 100%;
		background-color: #FFFFFF;
		padding: 134px 190px;
		box-sizing: border-box;
		margin-bottom: 45px;
	}

	.main ul {
		width: 560px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 208px;
	}

	.main ul li {
		/* width: 110px; */
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.main ul li img {
		width: 96px;
		height: 96px;
	}

	.main ul li p {
		font-size: 16px;
		font-weight: 400;
		text-align: center;
		color: #333333;
		line-height: 18px;
		margin-top: 30px;
	}
</style>
